import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { toast } from "react-hot-toast";
import Loader from "../components/Loader";
import { useNavigate } from "react-router-dom";
import MappingService from "../services/MappingService";
import { useBrand } from "./../helper/BrandContext";

const ScratchGenerator = ({ isLoggedIn }) => {
  const { brand } = useBrand();
  const mappingService = new MappingService();
  const [FromNo, setFromNo] = useState("");
  const [qty, setQty] = useState("");
  const [MfgDate, setMfgDate] = useState("");
  const [ToNo, setToNo] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    if (brand) {
      const storedToken = sessionStorage.getItem("token");
      if (storedToken) {
        isLoggedIn(true);
      } else {
        isLoggedIn(false);
        navigate("/login");
      }
      setTimeout(() => {
        setLoading(false); // Data has loaded, set loading to false
      }, 1000);
      GetFromNo(brand);
    }
  }, [brand]);

  async function submitHandler(event) {
    ;
    event.preventDefault();
    if (!qty || !MfgDate) {
      setErrorMessage("Please fill in all required fields");
    } else {
      setErrorMessage("");
      try {
        setLoading(true);
        const obj = {
          FromNo: FromNo,
          ToNo: ToNo,
          qty: qty,
          MfgDate: MfgDate,
          brandId: brand
        };

        mappingService.createscratch(obj).then((response) => {
          setLoading(false);
          if (response.responseCode == "200") {
            toast.success("Scratch Generated Successfully!");
            generateCSV(response.responseData);
            setFromNo("");
            setToNo("");
            setQty("");
            setMfgDate(null);
            GetFromNo(brand);
          } else if (response.responseCode == "400") {
            toast.error(response.responseMessage);
          }
        });
      } catch (error) {
        console.error("ScratchGenerator failed:", error);
        toast.error(error);
      }
    }
  }

  const handleQtyChange = (event) => {
    const newQty = event.target.value;
    setQty(newQty);
    const fromNo = parseInt(FromNo); // Assuming FromNo is an integer
    if (!isNaN(fromNo) && !isNaN(newQty)) {
      const newToNo = fromNo + parseInt(newQty) - 1;
      setToNo(newToNo);
    }
  };

  const handleDateChange = (event) => {
    setMfgDate(event.target.value);
  };

  function generateCSV(data) {
    const header = ["SeqNo", "ScratchCode"];
    const csvData = data.map((item) => [item.seqNo, item.scratch_code]);
    csvData.unshift(header);
    const csvContent =
      "data:text/csv;charset=utf-8," +
      csvData.map((row) => row.join(",")).join("\n");
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "Scratch.csv");
    document.body.appendChild(link);
    link.click();
  }

  function GetFromNo(brand) {
    mappingService
      .getFromNo(brand)
      .then((response) => {
        const data = response.responseData[0].fromNo;
        setFromNo(data);
      })
      .catch((error) => {
        console.error("API request failed:", error);
      });
  }

  return (
    <div>
      {loading ? (
        <Loader />
      ) : (
        <div className=" mt-3">
          <div className="container Mappingg">
            <div className="card">
              <div className="card-header mappping">
                <h1 className="text-center text-inverse">Scratch Generator</h1>
              </div>
              <div className="card-body">
                <form className="container" id="needs-validation" noValidate>
                  <div className="row">
                    <div className="col-lg-6 col-sm-6 col-12">
                      <div className="form-group">
                        <label
                          className="block text-gray-700 text-sm font-bold mb-2"
                          htmlFor="fromNo"
                        >
                          From No.
                        </label>
                        <input
                          className="appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                          id="fromNo"
                          type="number"
                          value={FromNo}
                          placeholder="Enter From Number"
                        />
                      </div>
                      <div className="form-group">
                        <label
                          className="block text-gray-700 text-sm font-bold mb-2"
                          htmlFor="qty"
                        >
                          Quantity
                        </label>
                        <input
                          className="appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                          id="qty"
                          type="text"
                          onChange={handleQtyChange}
                          placeholder="Enter Quantity"
                        />
                      </div>
                    </div>
                    <div className="col-lg-6 col-sm-6 col-12">
                      <div className="form-group">
                        <label
                          className="block text-gray-700 text-sm font-bold mb-2"
                          htmlFor="ToNo"
                        >
                          To No.
                        </label>
                        <input
                          className=" appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                          id="ToNo"
                          type="number"
                          readOnly
                          value={ToNo}
                          placeholder="Enter To Number"
                        />
                      </div>
                      <div className="form-group">
                        <label
                          className="block text-gray-700 text-sm font-bold mb-2"
                          htmlFor="MfgDate"
                        >
                          Mfg. Date
                        </label>
                        <input
                          className="appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                          id="MfgDate"
                          type="month"
                          defaultValue={MfgDate}
                          onChange={handleDateChange}
                          placeholder="Enter Mfg. Date"
                        />
                      </div>
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className="col-lg-12 col-sm-12 col-12 text-center my-3">
                      {errorMessage && (
                        <div className="text-red-500">{errorMessage}</div>
                      )}
                      <button
                        onClick={submitHandler}
                        className="bg-blue-500 mt-3 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                        type="button"
                      >
                        Submit
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ScratchGenerator;
